import type { MouseEvent } from 'react'

export const checkoutUrl =
  'https://43skvt-1y.myshopify.com/products/codigo-fitness-sistema-completo-de-alimentacion-saludable'

export function openCheckout() {
  if (window.self !== window.top) {
    window.open(checkoutUrl, '_blank', 'noopener,noreferrer')
    return
  }

  window.location.href = checkoutUrl
}

export function handleCheckoutClick(event: MouseEvent<HTMLAnchorElement>) {
  event.preventDefault()
  openCheckout()
}
